<template>
  <div :class="['studio-container', 'members-container', { 'm-top': !admin }, { 'admin-input': admin }]">
    <div v-if="admin" class="admin-header-sec">
      <h1 class="admin-title-sec">{{ $t('members') }}</h1>
      <div class="search-add-sec">
        <div class="text">{{ $t('search-by') + ':' }}</div>
        <select v-model="searchBy">
          <option value="name">{{ $t('name') }}</option>
          <option value="email">{{ $t('email') }}</option>
          <option value="studio">{{ $t('studio') }}</option>
        </select>
        <input v-if="searchBy == 'name'" type="text" :placeholder="$t('first-name')" v-model="firstName" />
        <input v-if="searchBy == 'name'" type="text" :placeholder="$t('last-name')" v-model="lastName" />
        <input v-if="searchBy == 'email'" type="text" :placeholder="$t('email')" v-model="email" />
        <div v-if="searchBy == 'studio'">
          <input type="text" @input="openSelectDropdown" @click="openSelectDropdown" v-model="studioFilter"
            :placeholder="$t('placeholder1')" />
          <div v-if="isDropdownOpen" class="dropdown-container">
            <div class="dropdown-options">
              <div v-for="studio in studios" :key="studio.id" @click="selectAnItem(studio)" class="dropdown-option">
                {{ studio.name }}
              </div>
            </div>
          </div>
        </div>
        <span class="fit20-btn save-btn-active" v-if="admin" @click="search">{{ $t('search') }}</span>
        <!-- <img width="50" @click.stop.prevent="handleButtonClick()" v-if="admin"
          src="http://storage.googleapis.com/fit20app-4-acctest.appspot.com/static/icons/%2B.png" /> -->
      </div>
    </div>
    <div class="result-div"
      v-if="(admin && admin_fit20.members.length > 0) || (!admin && fit20.studio.id && fit20.studio.members.length > 0)">
      <div class="flex search-members">
        <div class="member-filter-container">
          <input type="text" id="member_filter" :placeholder="$t('search')" @input="filterMembers" />
          <button class="clear-search" @click="clearSearch">×</button>
        </div>
        <div class="flex member-count" v-if="!admin">
          <div @click="filterByStatus('total')" class="total-member" v-if="membersCount.total > 0">
            <div>{{ membersCount.total }}</div>
            <img :src="fit20.storageBaseUrl + '/member/total-member.png'" />
          </div>
          <div @click="filterByStatus('solo')"
            :class="['member', { 'selected-member': memberFilters.includes('solo') }]" v-if="membersCount.solo > 0">
            <div>{{ membersCount.solo }}</div>
            <img :src="fit20.storageBaseUrl + '/member/member1.png'" />
          </div>
          <div @click="filterByStatus('duo')" :class="['member', { 'selected-member': memberFilters.includes('duo') }]"
            v-if="membersCount.duo > 0">
            <div>{{ membersCount.duo }}</div>
            <img :src="fit20.storageBaseUrl + '/member/member2.png'" />
          </div>
          <div @click="filterByStatus('trio')"
            :class="['member', { 'selected-member': memberFilters.includes('trio') }]" v-if="membersCount.trio > 0">
            <div>{{ membersCount.trio }}</div>
            <img :src="fit20.storageBaseUrl + '/member/member3.png'" />
          </div>
          <div @click="filterByStatus('onHold')"
            :class="['on-hold', { 'selected-on-hold': memberFilters.includes('onHold') }]"
            v-if="membersCount.onHold > 0">
            <div>{{ membersCount.onHold }}</div>
            <img :src="fit20.storageBaseUrl + '/member/onhold.png'" />
          </div>
          <div @click="filterByStatus('prospect')"
            :class="['prospect', { 'selected-prospect': memberFilters.includes('prospect') }]"
            v-if="membersCount.prospect > 0">
            <div>{{ membersCount.prospect }}</div>
            <img :src="fit20.storageBaseUrl + '/member/prospect.png'" />
          </div>
          <div @click="filterByStatus('guest')"
            :class="['guest', { 'selected-guest': memberFilters.includes('guest') }]" v-if="membersCount.guest > 0">
            <div>{{ membersCount.guest }}</div>
            <img :src="fit20.storageBaseUrl + '/member/guests.png'" />
          </div>
        </div>
      </div>
      <div class="studios" id='admin_members_sec'>
        <div class="studio-card" v-for="member, index in filteredMembers" :key="member.id + index"
          @click.stop.prevent="handleButtonClick(member.id)">
          <a :href="'#'" :id="member.id">
            <div class="flex card-div">
              <img loading="lazy"
                :src="member.photo ? (fit20.storageBaseUrl + '/member/' + member.id + '.png') : fit20.defaultMemberImg"
                height="auto" @error="handleImageError" />
              <!-- <img v-if="!member.photo && admin" :src="fit20.storageBaseUrl + '/member/default.svg'" height="auto" /> -->
              <p class="item-name">{{ member.firstName + " " + member.lastName }}</p>
            </div>
            <div class="right-bottom">
              <span v-if="member.partners && member.partners[0]">{{
                capitalizeFirstLetter(getPartnersNames(member.partners)) }}</span>
              <img :src="getLinkStatus(member)" @click.stop="addPartners(member)" />
            </div>
          </a>
        </div>
      </div>
    </div>
    <!-- start add partners popup -->
    <div class="popup-overlay " v-if="showPartners">
      <div class="partners-popup-overlay animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ $t('members-connected') }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="addPartners(false)" />
        </div>
        <div class="partners-body">
          <div>
            <br>
            <div class="partners-popup">
              <div class="flex sensor-row">
                <div class="sec1">
                  <img
                    :src="fit20.storageBaseUrl + '/member/' + (memberToPartners.photo ? memberToPartners.id + '.png' : 'default.svg')"
                    width="50" />
                </div>
                <div class="sec2">{{ memberToPartners.firstName + " " + memberToPartners.lastName }}</div>
                <div class="sec3">
                  <input type="checkbox" class="partners-checkbox" checked disabled />
                </div>
              </div>
              <div class="flex sensor-row partner-row" v-for="partner in partners">
                <div class="sec1">
                  <img :src="fit20.storageBaseUrl + '/member/' + (partner.photo ? partner.id + '.png' : 'default.svg')"
                    width="50" />
                </div>
                <div class="sec2">{{ partner.firstName + " " + partner.lastName }}</div>
                <div class="sec3">
                  <input type="checkbox" class="partners-checkbox" :checked="{ true: partner.id }"
                    @input="removePartner($event, partner)" />
                </div>
              </div>
            </div>
            <div class="partners-search"><input type="text" v-model="partnersFilter" :placeholder="$t('search')" />
            </div>
            <div class="partners-list-sec">
              <div class="partner-to-add-row" v-for="partner in partnersToAdd">
                <input @input="addPartner($event, partner)" type="checkbox" class="partners-checkbox"
                  :disabled="(!fit20.studio.trio && partners.length > 0) || (fit20.studio.trio && partners.length > 1) ? true : false" />
                <label>{{ partner.firstName + " " + partner.lastName + " " }}</label><img
                  v-if="partner.partners.length == 1" :src="fit20.storageBaseUrl + '/static/images/duo.svg'">
                <img v-if="partner.partners.length == 2" :src="fit20.storageBaseUrl + '/static/images/triple.svg'">
              </div>
            </div>
            <!-- <div class="btn-container">
              <span class="fit20-btn save-btn-disable" @click="savePartners()">{{
    $t('save')
                }}</span>
            </div> -->
            <div class="btn-container">
              <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
                @click="savePartners()">
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>
    <!-- end add partners popup -->

    <!-- start save unsaved sessions popup  -->
    <!-- showUnsavedSessionsPopup & tempSessions.length > 0 -->
    <div class="popup-overlay unsaved-session-popup" v-if="showUnsavedSessionsPopup & tempSessions.length > 0">
      <div class="edit-member animated zoomIn">
        <div class='popup-title flex'>
          <span>{{ $t('unsaved-sessions') }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'"
            @click="toggleUnsavedSessionsPopup(false)" />
        </div>
        <div class="flex edit-member-body">
          <form class="session-form-container" id="admin_studio_info">
            <div>{{ $t('unsaved-sessions-warning') }}</div>
            <div class="unsaved-session-div">
              <div v-for="session in tempSessions" :key="session.member" class="flex unsavedSession">
                <div class="item-text"><span class="member-name">{{ getMemberName(session.member) }}</span>{{ ' ' +
                  getBirthDate(session.date, fit20.user.language) + ' ' + session.exercises.length + ' ' +
                  $t('exercises') }}
                </div>
                <!-- <div class="btn-container fit20-btn save-btn-active btn" @click="saveSession(session)">{{ $t('save') }}
                </div> -->
              </div>
            </div>
            <br>
            <div class="btn-container" ref="save_all_unsaved_sessions">
              <span class="fit20-btn save-btn-active" @click="toggleUnsavedSessionsPopup(true)" style="width:'60px'">
                {{ $t('save') }}
              </span>
            </div>
            <br>
          </form>

          <!-- <div>
            <div class="fake-div"></div>
            <div class="btn-container">
              <div class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
                @click="toggleUnsavedSessionsPopup(true)">
                {{ $t('saveAll') }}
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { formattedDateTime } from "../actions/global.js";
export default {
  name: 'Members',
  components: {},
  props: ["fit20", "admin", "selectTab", "clearLocalStorage", "admin_fit20"],
  data() {
    return {
      tempSessions: [],


      showUnsavedSessionsPopup: false,
      memberBucketUrl: '',
      isDropdownOpen: false,
      filteredMembers: [],
      inputValue: '',
      studioFilter: '',
      searchBy: 'name',
      firstName: '',
      lastName: "",
      email: "",
      studios: "",
      isFilter: false,
      originalStudios: [],
      memberFilters: [],
      membersCount: {
        total: 0,
        solo: 0,
        duo: 0,
        trio: 0,
        onHold: 0,
        prospect: 0,
        guest: 0,
      },
      showPartners: false,
      memberToPartners: {},
      partners: [],
      partnersFilter: '',
      partnersToAdd: [],
      originalPartnersToAdd: []
    };
  },
  computed: {

  },
  methods: {
    getBirthDate(date, locale = 'en') {
      const birthDate = new Date(date);

      const day = String(birthDate.getDate()).padStart(2, '0');
      const month = String(birthDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const year = birthDate.getFullYear();

      if (locale == 'en') {
        // MM-DD-YYYY
        return `${month}-${day}-${year}`;
      } else {
        // DD-MM-YYYY
        return `${day}-${month}-${year}`;
      }
    },
    clearSearch() {
      let search = document.getElementById('member_filter');
      if (search) {
        search.value = '';
        let event = {
          target: {
            value: ""
          }
        }
        this.filterMembers(event);
      }
    },
    async saveSession(newSession) {
      this.fit20.isLoaded = false;
      try {
        let session = JSON.parse(JSON.stringify(newSession));
        // if exercises longer than 0......
        session.exercises.forEach(exe => {
          if (exe.order == "-") {
            if (exe.duration && exe.duration > 15) {
              exe.order = session.exercises.length;
            }
          }
        })
        session.exercises = session.exercises.filter(exe => exe.order != "-");
        // if (this.newSessionRemark.length > 0) {
        //   session.remark = this.newSessionRemark;
        // }
        if (session.id == 'new_session') {
          session.id = false;
        }


        let updateSession = await fetch(this.fit20.baseUrl + "/api/sessions/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(session),
        });

        let updatedSession = await updateSession.json();

        if (updatedSession.msg) {
          if (updatedSession.msg == "invalid-token") {
            this.clearLocalStorage();
          }
          // alert(this.$t(updatedSession.msg));
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t(updatedSession.msg) });
        } else {


          let tempSessions = JSON.parse(localStorage.getItem(this.fit20.studio.id)) || [];
          if (tempSessions.length > 0) {
            let targetedIndex = tempSessions.findIndex(
              session => session.member == newSession.member
            );

            if (targetedIndex !== -1) {
              // update existing session
              tempSessions.splice(targetedIndex, 1);
            }
            this.tempSessions = tempSessions;
            if (tempSessions.length == 0) {
              this.showUnsavedSessionsPopup = false;
            }
            // after actions on close reset the 
            localStorage.setItem(
              this.fit20.studio.id,
              JSON.stringify(tempSessions)
            );
          }

        }

        this.fit20.isLoaded = true;
        // reset the temp session 
        // localStorage.setItem("studioId", false);
      } catch (err) {
        this.fit20.isLoaded = true;
        console.log({ err });
        this.fit20.errors.push("Error in saveSession in Session.vue " + formattedDateTime());
        this.fit20.errors.push(JSON.stringify({
          message: err.message,
          stack: err.stack,
          name: err.name,
        }) + " " + formattedDateTime());
        this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
      }
    },
    getMemberName(id) {
      let member = this.fit20.studio.members.find(member => member.id == id);
      if (member) {

        return member.firstName + " " + member.lastName;
      }
    },
    toggleUnsavedSessionsPopup(saveAll) {
      if (saveAll) {
        this.tempSessions.map(session => {
          this.saveSession(session);
        });
        this.showUnsavedSessionsPopup = false;
      } else {
        this.tempSessions = [];
        localStorage.setItem(
          this.fit20.studio.id,
          JSON.stringify([])
        );
        this.showUnsavedSessionsPopup = false;
      }
      console.log('toggleUnsavedSessionsPopup');
    },
    addPartner: function (e, partner) {
      this.partners.push(partner);
      let partnerIndex = this.partnersToAdd.findIndex(p => p.id == partner.id);
      if (partnerIndex != -1) {
        this.partnersToAdd.splice(partnerIndex, 1);
        e.target.checked = false;
      }
      let partnerIndex2 = this.originalPartnersToAdd.findIndex(p => p.id == partner.id);
      if (partnerIndex2 != -1) {
        this.originalPartnersToAdd.splice(partnerIndex2, 1);
      }
    },
    removePartner: function (e, partner) {
      this.partnersToAdd.push(partner);
      this.partnersToAdd.sort((a, b) => a.firstName.localeCompare(b.firstName));
      let partnerIndex = this.partners.findIndex(p => p.id == partner.id);
      if (partnerIndex != -1) {
        this.partners.splice(partnerIndex, 1);
        // e.target.checked = false;
      }
      this.originalPartnersToAdd.push(partner);;
      this.originalPartnersToAdd.sort((a, b) => a.firstName.localeCompare(b.firstName));
    },
    addPartners: function (member) {
      this.partnersFilter = '';
      if (member) {
        this.memberToPartners = member;
        this.partnersToAdd = this.partnersToAdd.filter(member => this.memberToPartners.id != member.id && member.status != 'exMember' && member.status != 'exProspect').sort((a, b) => a.firstName.localeCompare(b.firstName));

        // console.log(this.partnersToAdd);
        let xxx = this.partnersToAdd.find(member => member.lastName == null);

        if (!this.fit20.studio.trio && this.memberToPartners.partners.length > 0) {
          // console.log(this.memberToPartners.partners);
          let partner1 = this.fit20.studio.members.find(member => member.id == this.memberToPartners.partners[0].id);
          // console.log(partner1);
          if (partner1) {
            this.partners.push(partner1);
            this.partnersToAdd = this.partnersToAdd.filter(member => partner1.id != member.id);

          }

        } else if (this.fit20.studio.trio && this.memberToPartners.partners.length > 0) {
          //console.log(this.memberToPartners.partners);
          this.memberToPartners.partners.forEach(partner => {
            let partnerToAdd = this.fit20.studio.members.find(member => member.id == partner.id);
            // console.log(partnerToAdd);
            this.partners.push(partnerToAdd);
            this.partnersToAdd = this.partnersToAdd.filter(member => partner.id != member.id);
          })
          // if (this.memberToPartners.partners.length == 1) {
          //   let partner1 = this.fit20.studio.members.find(member => member.id == this.memberToPartners.partners[0].id);
          //   console.log(partner1);
          //   this.partners.push(partner1);
          // }
          // if (this.memberToPartners.partners.length == 2) {
          //   let partner2 = this.fit20.studio.members.find(member => member.id == this.memberToPartners.partners[1].id);
          //   console.log(partner2);
          //   this.partners.push(partner2);
          // }
        }
        this.originalPartnersToAdd = JSON.parse(JSON.stringify(this.partnersToAdd));
      } else {
        this.partners = [];
        this.partnersToAdd = [...this.fit20.studio.members];
      }
      console.log('add partners');
      this.showPartners = !this.showPartners;
    },

    savePartners: async function () {
      let shouldUpdate = false;
      // console.log(this.memberToPartners.partners.length);
      this.fit20.logs.push('savePartners (Members.vue): partners length: ' + this.memberToPartners.partners.length);
      // console.log(this.partners.length);
      if (this.memberToPartners.partners.length > 0 || this.partners.length > 0) {
        if (this.partners.length == 0) {
          shouldUpdate = true;
          console.log("partners == 0");
          this.fit20.logs.push('savePartners (Members.vue): shouldUpdate: partners == 0');
        }
        if (this.partners.length == 1) {
          console.log("partners == 1");
          let partner1 = this.memberToPartners.partners.find(partner => partner.id == this.partners[0].id);
          if (!partner1 || this.memberToPartners.partners.length != this.partners.length) {
            shouldUpdate = true;
            this.fit20.logs.push('savePartners (Members.vue): shouldUpdate: partners == 1');
          }
        }
        if (this.partners.length == 2) {
          console.log("partners == 2");
          let partner1 = this.memberToPartners.partners.find(partner => partner.id == this.partners[0].id);
          let partner2 = this.memberToPartners.partners.find(partner => partner.id == this.partners[1].id);
          if (!partner1 || !partner2) {
            shouldUpdate = true;
          }
        }
      }
      // console.log(shouldUpdate);
      this.showPartners = false;
      if (shouldUpdate) {
        this.fit20.isLoaded = false;
        // console.log(this.partners);
        // console.log(this.partners[0]);
        //console.log(this.partners.length > 0);
        if (this.partners.length > 0) {
          //  console.log(JSON.parse(JSON.stringify(this.partners[0].partners)));
          this.fit20.logs.push('savePartners (Members.vue): shouldUpdate: partners > 0 : ' + JSON.stringify(this.partners[0].partners));
        }



        if (this.partners.length > 0 && this.partners[0].partners.length > 0) {
          console.log('should split >>>>>>>>>>>>>>>>');
          this.fit20.logs.push('savePartners (Members.vue): should split ');
          await this.splitPartners(this.partners[0]);
          if (this.partners.length == 2 &&
            this.partners[1] &&
            this.partners[1].partners &&
            this.partners[1].partners.length > 0) {
            await this.splitPartners(this.partners[1]);
          }
        }

        try {
          let body = {
            studioId: this.fit20.studio.id,
            member: this.memberToPartners,
            partners: this.partners
          };
          this.fit20.logs.push('savePartners (Members.vue): body:' + JSON.stringify(body));
          // console.log(body);
          let results = await fetch(this.fit20.baseUrl + "/api/members/partners/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
          });

          let result = await results.json();
          let res;
          if (result.msg) {
            if (result.msg == "invalid-token") {
              this.clearLocalStorage();
            }
            alert(this.$t(result.msg));
          } else {
            res = result;
          }
          if (res.updated) {
            console.log('partners updated');
            // console.log(this.partners);
            // console.log(this.memberToPartners);
            // console.log(this.memberToPartners.partners.length);
            this.fit20.logs.push('savePartners (Members.vue): start-update the front-end');
            if (this.partners.length > 0) {
              let mainMember = this.fit20.studio.members.find(m => m.id == this.memberToPartners.id);
              // remove all old partner

              if (this.memberToPartners.partners.length > 0) {

                let partner1 = this.fit20.studio.members.find(m => m.id == this.memberToPartners.partners[0].id);
                // console.log(partner1);
                // console.log(partner1.partners);
                //  console.log(partner1.partners.length);
                if (partner1 && partner1.partners && partner1.partners.length > 0) {
                  let partnerToRemove = partner1.partners.findIndex(p => p.id == this.memberToPartners.id);
                  partner1.partners.splice(partnerToRemove, 1);
                  console.log('remove the splitter from partner1');
                }
                if (this.memberToPartners.partners.length == 2) {
                  let partner2 = this.fit20.studio.members.find(m => m.id == this.memberToPartners.partners[1].id);
                  if (partner2 && partner2.partners && partner2.partners.length > 0) {
                    let partnerToRemove = partner2.partners.findIndex(p => p.id == this.memberToPartners.id);
                    partner2.partners.splice(partnerToRemove, 1);
                    let partner1ToRemove = partner2.partners.findIndex(p => p.id == partner1.id);
                    if (partner1ToRemove != -1) {
                      partner2.partners.splice(partner1ToRemove, 1);
                    }
                    let partner2ToRemove = partner1.partners.findIndex(p => p.id == partner2.id);
                    if (partner2ToRemove - 1) {
                      partner1.partners.splice(partner2ToRemove, 1);
                    }
                  }
                }
                if (mainMember) {
                  mainMember.partners = [];
                }
              }

              // add new partners
              let partner1 = this.fit20.studio.members.find(m => m.id == this.partners[0].id);
              if (partner1) {
                let x = JSON.parse(JSON.stringify(partner1));
                // console.log(x);
                // console.log(x.partners.length);
                // split the new partners from their old partners
                // if (partner1.partners.length > 0) {
                //   partner1.partners.forEach(p => {
                //     let p1 = this.fit20.studio.members.find(m => m.id == p.id);
                //     console.log(p1);
                //     p1 = p1.filter(m => m.id != partner1.id);
                //   });
                // }
                partner1.partners = [];
                partner1.partners.push({ id: this.memberToPartners.id, firstName: this.memberToPartners.firstName });

                if (mainMember) {
                  mainMember.partners.push({ id: this.partners[0].id, firstName: this.partners[0].firstName });
                }
              }
              if (this.partners.length == 2) {
                let partner2 = this.fit20.studio.members.find(m => m.id == this.partners[1].id);

                if (partner2) {
                  // // split the new partners from their old partners
                  // if (partner2.partners.length > 0) {
                  //   partner2.partners.forEach(p => {
                  //     let p1 = this.fit20.studio.members.find(m => m.id == p.id);
                  //     p1 = p1.filter(m => m.id != partner2.id);
                  //   });
                  // }
                  partner2.partners = [];
                  partner2.partners.push({ id: this.memberToPartners.id, firstName: this.memberToPartners.firstName });
                  partner2.partners.push({ id: partner1.id, firstName: partner1.firstName });
                  partner1.partners.push({ id: partner2.id, firstName: partner2.firstName });
                  if (mainMember) {
                    mainMember.partners.push({ id: this.partners[1].id });
                  }
                }
              }
            } else {
              // remove all partners
              console.log(" remove all partners");
              if (this.memberToPartners.partners.length > 0) {
                let partner1 = this.fit20.studio.members.find(m => m.id == this.memberToPartners.partners[0].id);
                if (partner1 && partner1.partners && partner1.partners.length > 0) {
                  let partnerToRemove = partner1.partners.findIndex(p => p.id == this.memberToPartners.id);
                  partner1.partners.splice(partnerToRemove, 1);
                }
                if (this.memberToPartners.partners.length == 2) {
                  let partner2 = this.fit20.studio.members.find(m => m.id == this.memberToPartners.partners[1].id);
                  if (partner2 && partner2.partners && partner2.partners.length > 0) {
                    let partnerToRemove = partner2.partners.findIndex(p => p.id == this.memberToPartners.id);
                    partner2.partners.splice(partnerToRemove, 1);
                    // let partner1ToRemove = partner2.partners.findIndex(p => p.id == partner1.id);
                    // if (partner1ToRemove != -1) {
                    //   partner2.partners.splice(partner1ToRemove, 1);
                    // }
                    // let partner2ToRemove = partner1.partners.findIndex(p => p.id == partner2.id);
                    // if (partner2ToRemove != -1) {
                    //   partner1.partners.splice(partner2ToRemove, 1);
                    // }
                  }
                }
                let mainMember = this.fit20.studio.members.find(m => m.id == this.memberToPartners.id);
                if (mainMember) {
                  mainMember.partners = [];
                }
              }
            }
            this.fit20.isLoaded = true;
          } else {
            console.log('something went wrong with update partner');
            window.alert(this.$t('update-partner-error'));
            this.fit20.isLoaded = true;
          }
        } catch (err) {
          console.log({ err });
          this.fit20.errors.push("Error in update partner in Members.js " + formattedDateTime());
          this.fit20.errors.push(JSON.stringify({
            message: err.message,
            stack: err.stack,
            name: err.name,
          }) + " " + formattedDateTime());
          window.alert(this.$t('general-err-msg'));
        }
        const tabToCloseIndex = this.fit20.currentMembers.findIndex(subArray => subArray.some(obj => obj.id == this.memberToPartners.id));
        // console.log(this.memberToPartners.id);
        // console.log(this.fit20.currentMembers);
        // console.log(tabToCloseIndex);
        if (tabToCloseIndex >= 0) {
          // this.fit20.currentMembers[tabToCloseIndex] = [];
          this.fit20.currentMembers.splice(tabToCloseIndex, 1, []);
          this.fit20.tabs['tab' + tabToCloseIndex + 2] = { active: false, action: '', exercisesControl: [] };
          this.selectTab('#members', 'tab_id1');
          // console.log(this.fit20.tabs);
        }
        if (this.partners.length > 0) {
          // console.log(this.partners[0].id);
          //  console.log(this.fit20.currentMembers);
          const tabToCloseIndex2 = this.fit20.currentMembers.findIndex(subArray => subArray.some(obj => obj.id == this.partners[0].id));
          // console.log(tabToCloseIndex2);
          if (tabToCloseIndex2 >= 0) {
            this.fit20.currentMembers.splice(tabToCloseIndex2, 1, []);
            this.fit20.tabs['tab' + tabToCloseIndex2 + 2] = { active: false, action: '', exercisesControl: [] }
          }
          if (this.partners.length == 2) {
            const tabToCloseIndex3 = this.fit20.currentMembers.findIndex(subArray => subArray.some(obj => obj.id == this.partners[1].id));
            // console.log(tabToCloseIndex3);
            if (tabToCloseIndex3 >= 0) {
              this.fit20.currentMembers.splice(tabToCloseIndex3, 1, []);
              this.fit20.tabs['tab' + tabToCloseIndex3 + 2] = { active: false, action: '', exercisesControl: [] }
            }
          }
        }
      }
      console.log('save partners');


      this.memberToPartners = {};

      this.partners = [];
    },
    splitPartners: async function (memberToPartners) {
      try {
        let body = {
          studioId: this.fit20.studio.id,
          member: memberToPartners,
          partners: [],
        };
        let results = await fetch(this.fit20.baseUrl + "/api/members/partners/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body),
        });

        let result = await results.json();
        let res;
        if (result.msg) {
          if (result.msg == "invalid-token") {
            this.clearLocalStorage();
          }
          alert(this.$t(result.msg));
        } else {
          res = result;
        }
        if (res.updated) {
          // remove all partners
          console.log(" remove all partners");
          let partner1 = this.fit20.studio.members.find(m => m.id == memberToPartners.partners[0].id);
          if (partner1 && partner1.partners && partner1.partners.length > 0) {
            let partnerToRemove = partner1.partners.findIndex(p => p.id == memberToPartners.id);
            partner1.partners.splice(partnerToRemove, 1);
          }
          if (memberToPartners.partners.length == 2) {
            let partner2 = this.fit20.studio.members.find(m => m.id == memberToPartners.partners[1].id);
            if (partner2 && partner2.partners && partner2.partners.length > 0) {
              let partnerToRemove = partner2.partners.findIndex(p => p.id == memberToPartners.id);
              partner2.partners.splice(partnerToRemove, 1);
              // let partner1ToRemove = partner2.partners.findIndex(p => p.id == partner1.id);
              // if (partner1ToRemove != -1) {
              //   partner2.partners.splice(partner1ToRemove, 1);
              // }
              // let partner2ToRemove = partner1.partners.findIndex(p => p.id == partner2.id);
              // if (partner2ToRemove != -1) {
              //   partner1.partners.splice(partner2ToRemove, 1);
              // }
            }
          }
          let mainMember = this.fit20.studio.members.find(m => m.id == memberToPartners.id);
          if (mainMember) {
            mainMember.partners = [];
          }
        } else {
          console.log('something went wrong with update partner');
          window.alert(this.$t('update-partner-error'));
          this.fit20.isLoaded = true;
        }
      } catch (err) {
        console.log({ err });
        this.fit20.errors.push("Error in update partner in Members.js " + formattedDateTime());
        this.fit20.errors.push(JSON.stringify({
          message: err.message,
          stack: err.stack,
          name: err.name,
        }) + " " + formattedDateTime());
        window.alert(this.$t('general-err-msg'));
      }
    },
    capitalizeFirstLetter(string) {
      if (string) {
        return string[0].toUpperCase() + string.slice(1);
      } else {
        return '';
      }
    },
    getPartnersNames(partners) {
      let names = '';
      if (!this.fit20.studio.trio && partners && partners.length > 0) {
        let partner1 = this.fit20.studio.members.find(member => member.id == partners[0].id);
        if (partner1) {
          names = partner1.firstName;
        }
      }
      if (this.fit20.studio.trio && partners && partners.length > 0) {
        let partner1 = this.fit20.studio.members.find(member => member.id == partners[0].id);
        if (partner1) {
          names = partner1.firstName;
        }
        if (partners.length == 2) {
          let partner2 = this.fit20.studio.members.find(member => member.id == partners[1].id);
          names = names + ' | ' + partner2.firstName;
        }
      }
      return names
    },
    handleImageError(event) {
      event.target.src = this.fit20.defaultMemberImg;
    },
    async search() {
      console.log("search");
      this.fit20.isLoaded = false;
      let filter;
      let searchBy;
      if (this.searchBy == 'name' && this.firstName && this.lastName) {
        filter = this.firstName + "--" + this.lastName;
        searchBy = 'name';
      } else if (this.searchBy == 'name' && this.firstName) {
        filter = this.firstName
        searchBy = 'firstName';
      } else if (this.searchBy == 'name' && this.lastName) {
        filter = this.lastName
        searchBy = 'lastName';
      } else if (this.searchBy == 'email') {
        filter = this.email
        searchBy = 'email';
      } else {
        filter = this.studio;
        // console.log(typeof filter);
        if (isNaN(filter)) {
          alert(this.$t('select-studio-err'));
          this.fit20.isLoaded = true;
          return;
        }
        searchBy = 'studio';
        if (filter.length < 1) {
          alert('empty-search');
        }
      }

      const getMembers = await fetch(this.fit20.baseUrl + "/api/members/filter/" + searchBy + "/" + filter + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
      let result = await getMembers.json();

      if (result.msg && result.msg == "invalid-token") {
        this.clearLocalStorage();
        alert(this.$t(result.msg));
      } else {
        this.admin_fit20.members = result;
        if (this.admin_fit20.members.msg) {
          this.admin_fit20.members = [];
        }
      }

      if (this.admin_fit20.members.length == 0) {
        alert('no-members-found');
      }
      this.fit20.isLoaded = true;
    },
    openSelectDropdown() {
      this.isDropdownOpen = true;
    },
    selectAnItem(item) {
      this.studioFilter = item.name;
      this.selectedItem = item;
      this.studio = item.id;
      this.isDropdownOpen = false;
    },
    async editMember(id) {
      console.log("edit member");
    },
    getStudio(e) {

    },
    async handleButtonClick(id) {
      if (this.admin) {
        if (id) {
          // await this.editMember(id);

          const res = await fetch(this.fit20.baseUrl + "/api/members/one/" + id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
          let result = await res.json();
          if (result.msg) {
            if (result.msg == "invalid-token") {
              this.clearLocalStorage();
            }
            alert(this.$t(result.msg));
          } else {
            this.admin_fit20.member = result;
          }
        } else {
          this.admin_fit20.member = {
            id: "new_member",
            firstName: "",
            lastName: "",
            studios: [],
            measure: [],
            height: 0,
            language: '',
          }
        }
        this.selectTab('#admin_member');
      } else {
        let noTapOpened;
        this.fit20.currentMembers.forEach((currentMember, index) => {
          if (currentMember.length > 0) {
            let openedTap = currentMember.find(member => member.id == id);
            if (openedTap) {
              noTapOpened = true;
              this.selectTab('tab_id' + (index + 2), 'tab_id' + (index + 2));
              return;
            }
          }
        });
        if (!noTapOpened) {
          try {
            if (this.fit20.currentMembers.every((array) => array.length > 0)) {
              // console.log(this.fit20.currentMembers);
              alert(this.$t('members-tabs-err'));
            } else {
              let selectedMember = await fetch(this.fit20.baseUrl + "/api/members/one/" + id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
              let result = await selectedMember.json();
              let primaryMember;
              if (result.msg) {
                if (result.msg == "invalid-token") {
                  this.clearLocalStorage();
                }
                alert(this.$t(result.msg));
              } else {
                primaryMember = result;
              }

              let emptyTab = this.fit20.currentMembers.find(tab => tab.length < 1);
              let emptyTabIndex = this.fit20.currentMembers.findIndex(tab => tab.length < 1);
              if (emptyTab) {
                emptyTab.push(primaryMember);
                let currentStudio = primaryMember.studios.find(studio => studio.id == this.fit20.studio.id);
                // console.log("currentStudio >>>>>>>>>>>>>>>>>>>>>>>>>>>");
                // console.log(currentStudio);
                if (currentStudio.partners.length > 0) {
                  let duo1 = await fetch(this.fit20.baseUrl + "/api/members/one/" + currentStudio.partners[0].id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
                  let result = await duo1.json();
                  if (result.msg) {
                    if (result.msg == "invalid-token") {
                      this.clearLocalStorage();
                    }
                    alert(this.$t(result.msg));
                  } else {
                    // check also if the duo partner has the primary member in his studio also check if he is active.
                    // console.log("duo partner" + result.status);
                    let duoCurrentStudio = result.studios.find(studio => studio.id == this.fit20.studio.id);
                    let partnerCheck;
                    if (duoCurrentStudio && duoCurrentStudio.partners && duoCurrentStudio.partners.length > 0) {
                      let findPrimaryMember = duoCurrentStudio.partners.find(partner => partner.id == id);
                      if (findPrimaryMember) {
                        partnerCheck = true;
                      }
                    }
                    // console.log(duoCurrentStudio);
                    if (result.status && !result.status.includes("ex") && partnerCheck) {
                      emptyTab.push(result);
                    }
                    // emptyTab.push(result);
                  }

                  if (currentStudio.partners.length == 2 && this.fit20.studio.trio) {
                    let duo2 = await fetch(this.fit20.baseUrl + "/api/members/one/" + currentStudio.partners[1].id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
                    let result = await duo2.json();
                    if (result.msg) {
                      if (result.msg == "invalid-token") {
                        this.clearLocalStorage();
                      }
                      alert(this.$t(result.msg));
                    } else {
                      emptyTab.push(result);
                    }
                  }
                }
                this.selectTab('#member-' + id, 'tab_id' + (emptyTabIndex + 2));
              }
            }
          } catch (err) {
            console.log({ err });
            this.fit20.errors.push("Error in handleButtonClick in Members.js " + formattedDateTime());
            this.fit20.errors.push(JSON.stringify({
              message: err.message,
              stack: err.stack,
              name: err.name,
            }) + " " + formattedDateTime());
            window.alert(this.$t('general-err-msg'));
          }
        }
      }
    },
    filterMembersByCriteria(members, criteria, searchWord, status) {
      return members.filter((member) => {
        const matchesSearchWord = (member.firstName.toLowerCase() + " " + (member.lastName ? member.lastName.toLowerCase() : '')).includes(searchWord);
        // console.log(matchesSearchWord);
        if (status == 'guest') {
          return (!member.main &&
            matchesSearchWord &&
            member.status !== 'exMember' &&
            member.status !== 'exProspect');
        } else if (status) {
          return (
            member.status == status &&
            matchesSearchWord &&
            member.status !== 'exMember' &&
            member.status !== 'exProspect');
        } else {
          return (
            // member.main &&
            member.partners.length === criteria.partners &&
            matchesSearchWord &&
            member.status !== 'exMember' &&
            member.status !== 'exProspect'
          );
        }
      });
    },
    filterByStatus(status) {
      let searchWord = $('#member_filter').val();
      if (status == 'total') {
        this.memberFilters = [];
        if (searchWord.length > 0) {
          let event = {
            target: {
              value: searchWord
            }
          };
          this.filterMembers(event);
        } else {
          this.filteredMembers = this.fit20.studio.members.filter(member => (member.status != 'exMember' && member.status != 'exProspect')).sort((a, b) => a.firstName.localeCompare(b.firstName));;
        }
      } else {
        const filter = this.memberFilters.indexOf(status);
        if (filter == -1) {
          this.memberFilters.push(status);
        } else {
          this.memberFilters.splice(filter, 1);
        }
        if (searchWord.length > 0) {
          let event = {
            target: {
              value: searchWord
            }
          };
          this.filterMembers(event);
        } else {
          if (this.memberFilters.length > 0) {
            let filteredMembers = [];
            this.memberFilters.forEach(filter => {
              if (filter == 'solo') {
                let solo = this.fit20.studio.members.filter(member => member.partners.length == 0 && (member.status != 'exMember' && member.status != 'exProspect'));
                filteredMembers = this.getUniqMembers([...filteredMembers, ...solo]);
              } else if (filter == 'duo') {
                let duo = this.fit20.studio.members.filter(member => member.partners.length == 1 && (member.status != 'exMember' && member.status != 'exProspect'));
                // console.log(filteredMembers.length);
                filteredMembers = this.getUniqMembers([...filteredMembers, ...duo]);
              } else if (filter == 'trio') {
                let trio = this.fit20.studio.members.filter(member => member.partners.length == 2 && (member.status != 'exMember' && member.status != 'exProspect'));
                filteredMembers = this.getUniqMembers([...filteredMembers, ...trio]);
              } else if (filter == 'onHold') {
                let onHold = this.fit20.studio.members.filter(member => member.status == 'onHold' && (member.status != 'exMember' && member.status != 'exProspect'));
                filteredMembers = this.getUniqMembers([...filteredMembers, ...onHold]);
              } else if (filter == 'prospect') {
                let prospect = this.fit20.studio.members.filter(member => member.status == 'prospect' && (member.status != 'exMember' && member.status != 'exProspect'));
                filteredMembers = this.getUniqMembers([...filteredMembers, ...prospect]);
              } else if (filter == 'guest') {
                let guest = this.fit20.studio.members.filter(member => !member.main && (member.status != 'exMember' && member.status != 'exProspect'));
                filteredMembers = this.getUniqMembers([...filteredMembers, ...guest]);
              }
            })
            this.filteredMembers = filteredMembers.sort((a, b) => a.firstName.localeCompare(b.firstName));;
          } else {
            this.filteredMembers = this.fit20.studio.members.filter(member => (member.status != 'exMember' && member.status != 'exProspect')).sort((a, b) => a.firstName.localeCompare(b.firstName));;
          }
        }
      }
    },
    getUniqMembers(arr) {
      const uniq = new Map();
      return arr.filter(item => {
        const keyValue = item.id; // Get the value of the specified key
        if (uniq.has(keyValue)) {
          return false; // If the key value has already been seen, filter out the item
        } else {
          uniq.set(keyValue, true); // Otherwise, add the key value to the map
          return true; // Include the item in the filtered array
        }
      });
    },
    filterMembers(event) {
      console.log('search excused');
      let searchWord = event.target.value.toLowerCase().trim();
      if (searchWord.length > 0 || this.memberFilters.length > 0) {
        if (this.admin) {
          this.filteredMembers = this.admin_fit20.members.filter(member => (member.firstName.toLowerCase() + " " + (member.lastName ? member.lastName.toLowerCase() : '')).includes(searchWord));
          this.filteredMembers.sort((a, b) => a.firstName.localeCompare(b.firstName));
        } else {
          if (this.memberFilters.length > 0) {
            // console.log(this.memberFilters);
            let filteredMembers = [];
            this.memberFilters.forEach((filter) => {
              let filtered;
              switch (filter) {
                case 'solo':
                  filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                    partners: 0
                  }, searchWord);
                  break;
                case 'duo':
                  filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                    partners: 1
                  }, searchWord);
                  break;
                case 'trio':
                  filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                    partners: 2
                  }, searchWord);
                  break;
                case 'onHold':
                  filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                    partners: 0
                  }, searchWord, 'onHold');
                  break;
                case 'prospect':
                  filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                    partners: 0
                  }, searchWord, 'prospect');
                  break;
                case 'guest':
                  filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                    partners: 0
                  }, searchWord, 'guest');
                  break;
              }

              filteredMembers = this.getUniqMembers([...filteredMembers, ...filtered]);

            });
            this.filteredMembers = filteredMembers.sort((a, b) => a.firstName.localeCompare(b.firstName));
          } else {
            this.filteredMembers = this.fit20.studio.members.filter((member) => {
              const matchesSearchWord =
                (member.firstName.toLowerCase() + " " + (member.lastName ? member.lastName.toLowerCase() : '')).includes(searchWord);
              this.filteredMembers.sort((a, b) => a.firstName.localeCompare(b.firstName));
              return (
                matchesSearchWord &&
                member.status !== 'exMember' &&
                member.status !== 'exProspect'
              );
            });
          }
        }
      } else {
        if (this.memberFilters.length > 0) {
          let filteredMembers = [];
          this.memberFilters.forEach((filter) => {
            let filtered;
            switch (filter) {
              case 'solo':
                filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                  partners: 0
                }, searchWord);
                break;
              case 'duo':
                filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                  partners: 1
                }, searchWord);
                break;
              case 'trio':
                filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                  partners: 2
                }, searchWord);
                break;
              case 'onHold':
                filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                  partners: 0
                }, searchWord);
                break;
              case 'prospect':
                filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                  partners: 0
                }, searchWord);
                break;
              case 'guest':
                filtered = this.filterMembersByCriteria(this.fit20.studio.members, {
                  partners: 0
                }, searchWord, 'guest');
                break;
            }
            // console.log(filtered);

            console.log('<<<<<<<<<<<<<< filtered2 >>>>>>>>>>>>>>>');
            filteredMembers = this.getUniqMembers([...filteredMembers, ...filtered]);

          });
          this.filteredMembers = filteredMembers.sort((a, b) => a.firstName.localeCompare(b.firstName));
        } else {
          this.filteredMembers = this.admin ? [...this.admin_fit20.members] : this.fit20.studio.members.filter(member => (member.status != 'exMember' && member.status != 'exProspect'));
          this.filteredMembers.sort((a, b) => a.firstName.localeCompare(b.firstName));
        }
      }
    },
    getLinkStatus(member) {
      let {
        status,
        partners,
        main
      } = member
      if (this.admin) {
        main = true;
      }
      let link;
      if (status == 'onHold' && main) {
        link = this.memberBucketUrl + "onhold.png";
      } else if (status == 'prospect' && main) {
        link = this.memberBucketUrl + "prospect.png";
      } else if (status == 'exProspect' && main) {
        link = this.memberBucketUrl + "ex-prospect.png";
      } else if (status == 'exMember' && main) {
        link = this.memberBucketUrl + "ex-member.png";
      } else if (status == 'member' || !main) {
        if (partners && partners.length == 1) {
          link = main ? this.memberBucketUrl + "member2.png" : this.memberBucketUrl + 'guest2.png';
        } else if (partners && partners.length == 2) {
          link = main ? this.memberBucketUrl + "member3.png" : this.memberBucketUrl + 'guest3.png';
        } else {
          link = main || this.admin ? this.memberBucketUrl + "member1.png" : this.memberBucketUrl + 'guest1.png';
        }
      }
      return link;
    }
  },
  mounted: function () {
    $('#admin_members_sec').scrollTop(0);

  },
  created: function () {
    this.memberBucketUrl = this.fit20.storageBaseUrl + '/member/';
    // check unsaved sessions
    let tempSessions = JSON.parse(localStorage.getItem(this.fit20.studio.id)) || [];
    if (tempSessions.length > 0) {
      this.showUnsavedSessionsPopup = true;
      this.tempSessions = tempSessions;
    }
  },
  watch: {
    'admin_fit20.members': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        // console.log(newVal);
        if (newVal) {
          this.filteredMembers = [...newVal];
        }
      }
    },
    'fit20.studios': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        // console.log(newVal);
        this.studios = [...newVal];
        this.originalStudios = [...newVal];
      }
    },
    'fit20.studio': {
      // immediate: true, // This runs the watcher immediately on mount
      // deep: true, // Watch for changes in nested properties
      handler(newVal) {
        let searchField = document.getElementById('member_filter');
        if (searchField) {
          searchField.value = "";
        }
        let tempSessions = JSON.parse(localStorage.getItem(this.fit20.studio.id)) || [];
        if (tempSessions.length > 0) {
          this.showUnsavedSessionsPopup = true;
          this.tempSessions = tempSessions;
        }
      }

    },
    'fit20.studio.members': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        // console.log(typeof newVal);
        if (newVal) {
          this.filteredMembers = newVal.filter(member => member.status != 'exMember' && member.status != 'exProspect' && member.firstName != '---').sort((a, b) => a.firstName.localeCompare(b.firstName));
          this.membersCount = this.filteredMembers.reduce((counts, member) => {
            if (member) {
              counts.total++;
            }
            if (member.partners.length === 0) {
              counts.solo++;
            } else if (member.partners.length === 1) {
              counts.duo++;
            } else if (member.partners.length === 2) {
              counts.trio++;
            }
            if (member.status === 'onHold') {
              counts.onHold++;
            }
            if (member.status === 'prospect') {
              counts.prospect++;
            }
            if (!member.main) {
              counts.guest++;
            }
            return counts;
          }, {
            total: 0,
            solo: 0,
            duo: 0,
            trio: 0,
            onHold: 0,
            prospect: 0,
            guest: 0
          });
          //console.log(this.membersCount);
          let event = {
            target: {
              value: ""
            }
          };
          event.target.value = $('#member_filter').val() || "";
          // console.log(event.target.value)
          this.memberFilters = [];
          this.filterMembers(event);
          this.partnersToAdd = newVal.filter(member => member.status != 'exMember' && member.status != 'exProspect').sort((a, b) => a.firstName.localeCompare(b.firstName));
          // this.originalPartnersToAdd = JSON.parse(JSON.stringify(this.partnersToAdd));
        }
      }
    },

    studioFilter: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal.length > 0) {
          this.studios = [...this.originalStudios].filter(studio => (studio.name).includes(newVal.toLowerCase().trim()));
          this.isFilter = true;
        } else if (this.isFilter) {
          this.studios = [...this.originalStudios];
          this.isFilter = false;
        }
      }
    },
    partnersFilter: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal.length > 0) {
          this.partnersToAdd = JSON.parse(JSON.stringify(this.originalPartnersToAdd)).filter(partner =>
            (partner.firstName && partner.firstName.toLowerCase().includes(newVal.toLowerCase().trim())) ||
            (partner.lastName && partner.lastName.toLowerCase().includes(newVal.toLowerCase().trim()))
          );
        } else {
          this.partnersToAdd = JSON.parse(JSON.stringify(this.originalPartnersToAdd));
        }
      }

    },
    'fit20.selectedTabHref': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        // console.log(newVal);
        if (newVal == '#admin_members') {
          $('#admin_members_sec').scrollTop(0);
        }
      }
    }
  }
};
</script>

<style>
.member-filter-container {
  width: 32%;
  position: relative;
}

.member-filter-container #member_filter {
  width: 100%;
}



.clear-search {
  position: absolute;
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #888;
  padding: 0;
  line-height: 1;
  top: 35px;
  right: 10px;
}

.members-container .text {
  padding: 10px 0;
}

.members-container .admin-header-sec select,
.members-container .admin-header-sec input {
  background: white;
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  /* width: 15%; */
  /* height: 40px; */
  /* padding-left: 5px; */
  margin-top: 0px;
}

.members-container .search-add-sec div input {
  width: 100% !important;
}

.members-container .member-count {
  width: 67%;
}

.members-container .flex.search-members {
  justify-content: space-between;
  padding-bottom: 10px;
}

.members-container .flex.member-count {
  height: 65px;
  text-align: center;
  justify-content: end;

}

.members-container .flex.member-count>div {
  position: relative;
  width: 55px;
  padding-top: 6px;
  margin-right: 10px;
  font-size: 17px;
  color: var(--fit20-gray);
}

.members-container .flex.member-count img {
  position: absolute;
  height: 35px;
  bottom: -1px;
  left: 13%;

}

.members-container .total-member {
  border: solid 2px var(--fit20-blue);
  border-radius: 10px;
}

.members-container .member {
  border: solid 2px var(--fit20-green);
  border-radius: 10px;
}

.members-container .selected-member {
  box-shadow: 0 0 5px var(--fit20-green);
}

.members-container .on-hold {
  border: solid 2px var(--fit20-gray);
  border-radius: 10px;
}

.members-container .selected-on-hold {
  box-shadow: 0 0 5px var(--fit20-gray);
}

.members-container .prospect {
  border: solid 2px var(--fit20-pink);
  border-radius: 10px;
}

.members-container .selected-prospect {
  box-shadow: 0 0 5px var(--fit20-pink);
}

.members-container .guest {
  border: solid 2px var(--fit20-orang);
  border-radius: 10px;
}

.members-container .selected-guest {
  box-shadow: 0 0 5px var(--fit20-orang);
}

.members-container .save-btn-active {
  padding: 10px 20px !important;
}

.studio-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.members-container.m-top {
  top: 90px;
}

.members-container .result-div {
  position: absolute;
  /* top: 0;
  left: 0; */
  padding: 10px 10px;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.members-container .search-add-sec {
  display: flex;
  justify-content: space-between;
}

.members-container .search-add-sec img {
  width: 60px;
  /* min-width: 0px;
  min-height: 0px; */
}

.members-container input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 7px 5px;
  width: 32%;
  height: 40px;
  margin-top: 25px;
  margin-left: 5px;
}

.members-container .admin-input input {
  width: 23% !important;
  margin-top: 0px !important;
}

.members-container .right-bottom {
  text-align: right;
  position: absolute;
  width: 70%;
  bottom: -7px;
  right: 5px;
}

.members-container .right-bottom span {
  position: relative;
  bottom: 10px;
  color: var(--fit20-gray);
}

.members-container .right-bottom img {
  width: 55px;
}

.members-container .partners-popup-overlay {
  background-color: white;
  min-width: 40%;
  border-radius: 10px;
}

.members-container .partners-popup-overlay input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 5px 5px;
  width: 90%;
  height: 30px;
  margin-top: 25px;
  margin-left: 5px;
}

.members-container .partners-popup-overlay input[type="checkbox"] {
  border: solid 1px var(--fit20-lighter-gray) !important;
  border-radius: 0px !important;
  padding: 0px !important;
  width: 25px;
  height: 25px !important;
  margin-top: 0px !important;
  margin-left: 5px;
}

.members-container .partners-popup-overlay .partners-popup input {
  border: solid 1px var(--fit20-lighter-gray) !important;
  /* color: var(--fit20-lighter-gray);
  background-color: white; */
  accent-color: var(--fit20-light-gray);
}

.members-container .partners-popup {
  position: relative;
}

.members-container .partners-popup .sec1 img {
  border-radius: 10px;
}

.members-container .partners-popup .partner-row {
  margin-top: 15px;
}

.members-container .partners-popup .sec1,
.members-container .partners-popup .sec2 {
  margin-left: 15px;
}


.members-container .partners-popup .sec2 {
  padding-top: 30px;
}

.members-container .partners-popup .sec3 {
  position: absolute;
  right: 20px;
  padding-top: 20px;
}

.members-container .partners-body .partners-search {
  margin: auto;
  text-align: center;
}

.members-container .partners-body .partners-list-sec {
  margin: 15px 0 0 15px;
  height: 150px;
  overflow: auto;
}

.members-container .partners-body .partners-list-sec .partner-to-add-row {
  margin-top: 8px;
}

.partner-to-add-row img {
  width: 20px;
}

.members-container .partners-list-sec label {
  margin-left: 15px;
}

.unsaved-session-popup .popup-title {
  background-color: var(--fit20-orang);
}

.unsaved-session-popup .animated:not(.not) {
  border: solid 3px var(--fit20-orang);
}

.unsaved-session-div {
  margin-top: 10px;
}

.unsavedSession {
  justify-content: space-between;
  margin-top: 5px;
}

.member-name {
  color: var(--fit20-blue);
}

.item-text {
  padding-top: 18px;
}

.session-form-container {
  margin: 0 auto;
}
</style>
